module.exports = __webpack_public_path__ + "media/landing-page/tnt-bubble-f425442c.png";